<template>
    <div class="form-field form-field__input form-field__textarea" :class="rootClasses">
        <label class="form-field--title-label"
                v-if="label"
                :for="id"
                v-html="label"/>
        <div class="form-field--input-container" :data-action-count="0">
            <span class="form-field--floating-label"
                    aria-hidden="true"
                    v-if="label && hasFloatingLabel"
                    v-html="label"/>
            <textarea class="form-field--input"
                    ref="input"
                    v-bind="inputAttrs"
                    v-model="model"
                    @focus="onFocus"
                    @blur="onBlur"/>
        </div>
        <form-field-messages :messages="messages"/>
    </div>
</template>

<script>
    import FormFieldMessages from 'framework/components/form//form-field-messages/form-field-messages';
    import formFieldAbstractMixin from 'framework/mixins/form/form-field-abstract';

    const TEXTAREA_BORDER_WIDTH = 1;
    const TEXTAREA_MAX_HEIGHT = 240;

    export default {
        components: {
            FormFieldMessages,
        },
        mixins: [
            formFieldAbstractMixin,
        ],
        props: {
            value: {
                type: [Number, String],
                required: true,
            },
            rows: {
                type: Number,
                default: 1,
            },
            autocomplete: {
                type: String,
                default: null,
            },
            maxlength: {
                type: Number,
                default: null,
            },
        },
        computed: {
            specificRootClasses() {
                return [
                    this.bemIf(this.hasFocus, 'has-focus'),
                ];
            },
            specificInputAttrs() {
                const { autocomplete, maxlength, placeholder, rows } = this;
                return { autocomplete, maxlength, placeholder, rows };
            },
        },
        methods: {
            updateHeight(isExpanding) {
                const { input } = this.$refs;

                if (!input) {
                    return;
                }

                if (input.offsetHeight > TEXTAREA_MAX_HEIGHT) {
                    input.style.overflow = 'auto';
                    return;
                }

                if (isExpanding) {
                    const contentHeight = input.scrollHeight + (TEXTAREA_BORDER_WIDTH * 2);
                    input.style.height = this.value ? `${ Math.min(TEXTAREA_MAX_HEIGHT, contentHeight) }px` : 'auto';
                    input.style.overflow = contentHeight >= TEXTAREA_MAX_HEIGHT ? 'auto' : 'hidden';
                }
            },
        },
        watch: {
            value: {
                handler(value = '', previousValue = '') {
                    this.updateHeight((value.length - previousValue.length) > 0);
                },
                immediate: true,
            },
        },
        mounted() {
            this.updateHeight(true);
        },
    };
</script>
